module.exports = __webpack_public_path__ + "img/showers.e498994e.svg";